import apiClient, { handleApiError } from '../lib/api-client';
import { API_ENDPOINTS } from '../config/api';

export interface IndianFoodItem {
  id: string;
  name: string;
  nameTamil?: string;
  category: string;
  region: string;
  caloriesPer100g: number;
  carbsPer100g: number;
  proteinPer100g: number;
  fatPer100g: number;
  fiberPer100g?: number;
  glycemicIndex?: number;
  typicalServingSize: number;
}

export const indianFoodService = {
  async search(params?: { category?: string; region?: string; q?: string; limit?: number }) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.INDIAN_FOOD.SEARCH, { params });
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },

  async getCategories(): Promise<string[]> {
    try {
      const response = await apiClient.get(API_ENDPOINTS.INDIAN_FOOD.CATEGORIES);
      const data = response.data?.data ?? response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw new Error(handleApiError(error));
    }
  },

  async lookupBarcode(code: string) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.INDIAN_FOOD.BARCODE(code));
      return response.data?.data ?? response.data;
    } catch (error) {
      return null;
    }
  },
};
